import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useMemo, useRef } from "react";
import { Tab, TabContent } from ".";
import { TabData, TabProps } from "./Tab";
import { faTableCells } from "@fortawesome/pro-regular-svg-icons/faTableCells";
import { faChartColumn } from "@fortawesome/pro-regular-svg-icons/faChartColumn";
import { faSquareInfo } from "@fortawesome/pro-regular-svg-icons/faSquareInfo";
import uuid from "react-uuid";
import styles from "./TogglePanel.module.scss";
import plainPlanelStyles from "./PlainPanel.module.scss";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export interface TogglePanelProps extends TabProps {}

export const TogglePanel: React.FC<TogglePanelProps> = ({ children, tabData, className, ...props }) => {
    return (
        <Tab tabData={tabData} {...props} variant="blank" className={`${className ?? ""} ${styles.togglePanel ?? ""}`}>
            {children}
        </Tab>
    );
};

export interface GraphTableInfoToggleProps {
    title?: string | JSX.Element;
    graph?: JSX.Element;
    table?: JSX.Element;
    info?: JSX.Element;
    className?: string;
    onTabActivated?: (tab: TabData) => void;
}

const GraphTableInfoTabType = {
    GRAPH: "graph",
    TABLE: "table",
    INFO: "info"
};

export const GraphTableInfoToggle: React.FC<GraphTableInfoToggleProps> = ({
    className,
    title,
    graph,
    table,
    info,
    onTabActivated
}) => {
    const hasGraph = graph != null;
    const hasTable = table != null;
    const hasInfo = info != null;
    const _uuid = useRef(uuid());

    // const [graphHasNoContent, setGraphHasNoContent] = useState(false);
    // const [tableHasNoContent, setTableHasNoContent] = useState(false);
    // const [infoHasNoContent, setInfoHasNoContent] = useState(false);

    const onTooltipEntered = useCallback((contentClassName: string, tooltipClassName: string) => {
        return () => {
            // const content = document.getElementById(
            //     contentClassName
            //     // `${_uuid.current}-info`
            // );
            // const tooltip = document.getElementById(
            //     tooltipClassName
            //     // `${_uuid.current}-tooltip-info`
            // );
            // if (content && content?.getBoundingClientRect) {
            //     const tooltipLeft = tooltip?.getBoundingClientRect()?.left;
            //     const contentLeft = content?.getBoundingClientRect()?.left;
            //     const contentWidth = content?.getBoundingClientRect()?.width / 2;
            //     const arrowLeft = -tooltipLeft + (contentLeft + contentWidth / 2);
            //     if (arrowLeft >= 0) {
            //         const tooltipArrow = tooltip.querySelector(".tooltip-arrow");
            //         if (tooltipArrow) {
            //             (tooltipArrow as HTMLDivElement).style.left = `${arrowLeft}px`;
            //             (tooltipArrow as HTMLDivElement).style.bottom = `1px`;
            //             (tooltipArrow as HTMLDivElement).style.opacity = `1`;
            //             (tooltipArrow as HTMLDivElement).style.borderLeft = `10px solid transparent`;
            //             (tooltipArrow as HTMLDivElement).style.borderRight = `10px solid transparent`;
            //             (tooltipArrow as HTMLDivElement).style.borderTop = `10px solid black`;
            //         }
            //     }
            // }
        };
    }, []);

    const onTooltipEnter = useCallback((contentClassName: string, tooltipClassName: string) => {
        return () => {
            // const content = document.getElementById(
            //     contentClassName
            //     // `${_uuid.current}-info`
            // );
            // const tooltip = document.getElementById(
            //     tooltipClassName
            //     // `${_uuid.current}-tooltip-info`
            // );
            // if (content && content?.getBoundingClientRect) {
            //     const tooltipArrow = tooltip.querySelector(".tooltip-arrow");
            //     if (tooltipArrow) {
            //         (tooltipArrow as HTMLDivElement).style.opacity = `1`;
            //         (tooltipArrow as HTMLDivElement).style.bottom = `30px`;
            //         (tooltipArrow as HTMLDivElement).style.left = `10px`;
            //         // (tooltipArrow as HTMLDivElement).style.left = `0px`;
            //     }
            // }
        };
    }, []);

    const onTooltipExit = useCallback((contentClassName: string, tooltipClassName: string) => {
        return () => {
            // const content = document.getElementById(contentClassName);
            // const tooltip = document.getElementById(tooltipClassName);
            // if (content && content?.getBoundingClientRect) {
            //     const tooltipArrow = tooltip.querySelector(".tooltip-arrow");
            //     if (tooltipArrow) {
            //         (tooltipArrow as HTMLDivElement).style.display = `none`;
            //     }
            // }
        };
    }, []);

    const [
        onGraphEnter,
        onGraphEntered,
        onGraphExit,
        onTableEnter,
        onTableEntered,
        onTableExit,
        onInfoEnter,
        onInfoEntered,
        onInfoExit
    ] = useMemo(() => {
        return [
            onTooltipEnter(`${_uuid.current}-graphs`, `${_uuid.current}-tooltip-graphs`),
            onTooltipEntered(`${_uuid.current}-graphs`, `${_uuid.current}-tooltip-graphs`),
            onTooltipExit(`${_uuid.current}-graphs`, `${_uuid.current}-tooltip-graphs`),
            onTooltipEnter(`${_uuid.current}-table`, `${_uuid.current}-tooltip-table`),
            onTooltipEntered(`${_uuid.current}-table`, `${_uuid.current}-tooltip-table`),
            onTooltipExit(`${_uuid.current}-table`, `${_uuid.current}-tooltip-table`),
            onTooltipEnter(`${_uuid.current}-info`, `${_uuid.current}-tooltip-info`),
            onTooltipEntered(`${_uuid.current}-info`, `${_uuid.current}-tooltip-info`),
            onTooltipExit(`${_uuid.current}-info`, `${_uuid.current}-tooltip-info`)
        ];
    }, [onTooltipEnter, onTooltipEntered, onTooltipExit]);

    const tabData = React.useMemo<TabData[]>(() => {
        return [
            hasGraph
                ? {
                      id: GraphTableInfoTabType.GRAPH,
                      title,
                      shortTitle: (
                          //   <OverlayTrigger
                          //       placement="top"
                          //       overlay={<Tooltip id={`${_uuid.current}-charts`}>Charts and figures</Tooltip>}
                          //   >
                          //       <div className="toggle-button">
                          //           <FontAwesomeIcon icon={faChartColumn} />
                          //       </div>
                          //   </OverlayTrigger>

                          <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id={`${_uuid.current}-tooltip-graphs`}>Charts and figures</Tooltip>}
                              onEnter={onGraphEnter}
                              onEntered={onGraphEntered}
                              onExit={onGraphExit}
                          >
                              <div className="toggle-button" id={`${_uuid.current}-graphs`}>
                                  <FontAwesomeIcon icon={faChartColumn} />
                              </div>
                          </OverlayTrigger>
                      )
                  }
                : undefined,
            hasTable
                ? {
                      id: GraphTableInfoTabType.TABLE,
                      title,
                      shortTitle: (
                          //   <div className="toggle-button" title="Data tables, downloads and scheme breakdowns">
                          //       <FontAwesomeIcon icon={faTableCells} />
                          //   </div>

                          <OverlayTrigger
                              placement="top"
                              overlay={
                                  <Tooltip id={`${_uuid.current}-tooltip-table`}>
                                      {" "}
                                      Data tables, downloads and scheme breakdowns
                                  </Tooltip>
                              }
                              onEnter={onTableEnter}
                              onEntered={onTableEntered}
                              onExit={onTableExit}
                          >
                              <div className="toggle-button" id={`${_uuid.current}-table`}>
                                  <FontAwesomeIcon icon={faTableCells} />
                              </div>
                          </OverlayTrigger>
                      )
                  }
                : undefined,
            hasInfo
                ? {
                      id: GraphTableInfoTabType.INFO,
                      title,
                      shortTitle: (
                          //   <div className="toggle-button" title="Supporting information and indicator definitions">
                          //       <FontAwesomeIcon icon={faSquareInfo} />
                          //   </div>
                          <OverlayTrigger
                              placement="top"
                              overlay={
                                  <Tooltip id={`${_uuid.current}-tooltip-info`}>
                                      Supporting information and indicator definitions
                                  </Tooltip>
                              }
                              onEnter={onInfoEnter}
                              onEntered={onInfoEntered}
                              onExit={onInfoExit}
                          >
                              <div className="toggle-button" id={`${_uuid.current}-info`}>
                                  <FontAwesomeIcon icon={faSquareInfo} />
                              </div>
                          </OverlayTrigger>
                      )
                  }
                : undefined
        ].filter(d => d != null);
    }, [
        title,
        hasGraph,
        hasTable,
        hasInfo,

        onGraphEnter,
        onGraphEntered,
        onGraphExit,
        onTableEnter,
        onTableEntered,
        onTableExit,
        onInfoEnter,
        onInfoEntered,
        onInfoExit
    ]);

    const has = [hasGraph, hasTable, hasInfo].filter(d => d === true);

    if (!has?.length) return null;

    return (
        <TogglePanel
            tabData={tabData}
            // className={`${className ?? ""} ${has?.length === 1 ? `${plainPlanelStyles.plain ?? ""}` : ""}
            // ${graphHasNoContent ? "graph-no-content" : ""}
            // ${tableHasNoContent ? "table-no-content" : ""}
            // ${infoHasNoContent ? "info-no-content" : ""}
            // `}
            className={`${className ?? ""} ${has?.length === 1 ? `${plainPlanelStyles.plain ?? ""}` : ""} toggle-panel`}
        >
            {hasGraph === true && (
                <TabContent
                    id={GraphTableInfoTabType.GRAPH}
                    onLongTitleClick={e => {
                        e.stopPropagation();
                    }}
                    onActivated={onTabActivated}
                    // onClick={e => {
                    //     console.log(e);
                    // }}
                    // onNoContent={nocontent => {
                    //     setGraphHasNoContent(nocontent);
                    // }}
                >
                    {graph}
                </TabContent>
            )}
            {hasTable === true && (
                <TabContent
                    id={GraphTableInfoTabType.TABLE}
                    onLongTitleClick={e => {
                        e.stopPropagation();
                    }}
                    onActivated={onTabActivated}
                    // onNoContent={nocontent => {
                    //     setTableHasNoContent(nocontent);
                    // }}
                >
                    {table}
                </TabContent>
            )}
            {hasInfo === true && (
                <TabContent
                    id={GraphTableInfoTabType.INFO}
                    onLongTitleClick={e => {
                        e.stopPropagation();
                    }}
                    onActivated={onTabActivated}
                    // onNoContent={nocontent => {
                    //     setInfoHasNoContent(nocontent);
                    // }}
                >
                    {info}
                </TabContent>
            )}
        </TogglePanel>
    );
};

export const GraphTableInfoToggleDemo = () => {
    return (
        <GraphTableInfoToggle
            title={"test"}
            graph={
                <>
                    <div>graph</div>
                </>
            }
            table={
                <>
                    <div>table</div>
                </>
            }
            info={
                <>
                    <div>info</div>
                </>
            }
        />
    );
};
